
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'


export default {
components: {
XHeader,
Box,
XButton,
Group,
CellBox,
Cell,
Scroller,
Icon
},
data() {
return {
title: 'API管理',
list: [
{ name: 'OKEX自动交易', market: 'OKEX' },
{ name: 'OKEX自动交易', market: 'OKEX' }
]
}
}
}



// WEBPACK FOOTER //
// ./src/components/usercenter/ApiList.vue